import { useMemo } from 'react';
import { Typography } from 'seagull';
import { LegalTerms } from "../../../../components/AgreementStudioPage/AgreementStudioModal/LegalTerms/LegalTerms";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { jsx as _jsx } from "react/jsx-runtime";
const getLegalTermErrors = legalTerms => {
  return legalTerms.map(legalTerm => {
    var _legalTerm$termsOfSer;
    const errors = {};
    if (legalTerm === null) {
      errors.legalTermField = 'Please choose a document';
    }
    if ((legalTerm === null || legalTerm === void 0 || (_legalTerm$termsOfSer = legalTerm.termsOfService) === null || _legalTerm$termsOfSer === void 0 ? void 0 : _legalTerm$termsOfSer.type) === 'explicitApproval') {
      var _legalTerm$termsOfSer2, _legalTerm$termsOfSer3;
      if (!((_legalTerm$termsOfSer2 = legalTerm.termsOfService.explicitApproval.statement) !== null && _legalTerm$termsOfSer2 !== void 0 && _legalTerm$termsOfSer2.trim())) {
        errors.explicitApproval = 'Please enter a checkbox statement';
      } else if (((_legalTerm$termsOfSer3 = legalTerm.termsOfService.explicitApproval.statement) === null || _legalTerm$termsOfSer3 === void 0 ? void 0 : _legalTerm$termsOfSer3.length) > 120) {
        errors.explicitApproval = 'The statement can be up to 120 characters';
      }
    }
    return errors;
  });
};
const hasLegalTermsErrors = legalTerms => {
  return legalTerms.length === 0 || getLegalTermErrors(legalTerms).some(error => error.legalTermField || error.explicitApproval);
};
function TermsOfServiceModalContent(_ref) {
  let {
    draft,
    setDraft,
    wasSubmitted
  } = _ref;
  const legalTermsDocuments = draft.legalTermsDocuments();
  const errors = useMemo(() => wasSubmitted ? getLegalTermErrors(legalTermsDocuments) : [], [wasSubmitted, legalTermsDocuments]);
  const onAgreementLegalTermsChange = updatedLegalTerms => {
    setDraft(draft.setLegalTermsDocuments(updatedLegalTerms));
  };
  return /*#__PURE__*/_jsx(LegalTerms, {
    withTitle: false,
    withExplicitApproval: true,
    agreementLegalTerms: legalTermsDocuments,
    onAgreementLegalTermsChange: onAgreementLegalTermsChange,
    errors: errors,
    editContext: "proposal",
    sourceId: draft.id()
  });
}
export default function TermsOfServiceCell(_ref2) {
  let {
    isDisabled,
    disabledTooltip,
    draft,
    index,
    onOpenModal
  } = _ref2;
  const agreementLegalTermsDocuments = draft.legalTermsDocuments();
  const onClick = () => onOpenModal({
    submitOnNotDirty: true,
    shouldSubmit: async editedDraft => {
      return !hasLegalTermsErrors(editedDraft.legalTermsDocuments());
    },
    width: '700px',
    maxHeight: '600px',
    renderContent: _ref3 => {
      let {
        draft,
        setDraft,
        wasSubmitted
      } = _ref3;
      return {
        title: 'Terms of service',
        testId: 'edit-terms-modal',
        content: /*#__PURE__*/_jsx(TermsOfServiceModalContent, {
          draft: draft,
          setDraft: setDraft,
          wasSubmitted: wasSubmitted
        }),
        onSubmit: defaultBehavior => {
          defaultBehavior();
        }
      };
    }
  });
  const getLegalTermsName = () => {
    var _agreementLegalTermsD, _agreementLegalTermsD2;
    if (agreementLegalTermsDocuments.length > 1) {
      return "".concat(agreementLegalTermsDocuments.length, " documents");
    }
    return (_agreementLegalTermsD = agreementLegalTermsDocuments === null || agreementLegalTermsDocuments === void 0 || (_agreementLegalTermsD2 = agreementLegalTermsDocuments[0]) === null || _agreementLegalTermsD2 === void 0 ? void 0 : _agreementLegalTermsD2.displayName) !== null && _agreementLegalTermsD !== void 0 ? _agreementLegalTermsD : '';
  };
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testId: "edit-terms-of-service-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      testId: "terms-of-service-".concat(index),
      children: getLegalTermsName()
    })
  });
}